import { render, staticRenderFns } from "./PricesImportPopup.vue?vue&type=template&id=40b703cb&"
import script from "./PricesImportPopup.vue?vue&type=script&lang=js&"
export * from "./PricesImportPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports